import { useEffect, useState } from 'react';
import { CurrencyIcon } from '~/components/collections';
import { TextInput } from '~/components/ui/TextInput';
import { useWalletIcon } from '~/hooks';
import { Currency } from '~/shared';
import { StyledContainer } from './MoneyInput.styled';

const MoneyInput = ({
	value,
	onChange,
	placeholder,
}: {
	value: number;
	onChange: (newValue: number) => void;
	placeholder?: string;
}) => {
	const [inputValue, setInputValue] = useState<number>(value || 0);

	const rubleIcon = useWalletIcon(Currency.Ruble, true);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		e.preventDefault();
		const inputValue = e.target.value.replace(/\D/g, '');

		if (inputValue.length === 0) {
			setInputValue(0);
			onChange(0);
			return;
		}

		setInputValue(parseInt(inputValue));
		onChange(parseInt(inputValue));
	};

	useEffect(() => {
		setInputValue(value ?? 0);
	}, [value]);

	return (
		<StyledContainer $active={inputValue > 0}>
			<TextInput
				fontSize={16}
				height={50}
				onChange={handleChange}
				active={inputValue > 0}
				value={inputValue ? inputValue.toLocaleString('ru-RU') : ''}
				placeholder={placeholder}
				style={{
					padding: '0 60px 0 20px',
				}}
			/>
			<CurrencyIcon icon={rubleIcon} size="lg" />
		</StyledContainer>
	);
};

export { MoneyInput };
